<template>
	<div v-parallax-fit="parallax" class="foto">
		<!-- <img src="/themes/rise-theme/dist/images/estate/character-view/ozzie/29_FinalPhoto_05@2x.png" alt=""> -->
	</div>
</template>

<script>
export default {
	data() {
		return {
			parallax: [
				{
					start: 36200,
					end: 37200,
					fromStyle: { transform: 'translateY(-500%) translateX(0%)' },
					toStyle: { transform: 'translateY(0%) translateX(0%)' },
					easing: 'linear'
				},
				{
					start: 37800,
					end: 38200,
					fromStyle: { transform: 'translateY(0%) translateX(0%)' },
					toStyle: { transform: 'translateY(500%) translateX(0%)' },
					easing: 'linear'
				},
			]
		}
	}
}
</script>

<style lang="scss" scoped>
.foto {
	position: absolute;
	right: 0;
	bottom: 0;
	max-width: 350px;
	margin-right: -75px;
	margin-bottom: 55px;
	transition: all 0.5s linear;
}

@media screen and (max-width: 991px) {
	.foto {
		max-width: 300px;
		margin-right: -87px;
		margin-bottom: 20px;
	}
}

@media screen and (max-width: 650px) {
	.foto {
		max-width: 200px;
		margin-right: -40px;
		margin-bottom: 6px;
	}
}
</style>
